(function(angular){
    'use strict';
    /**
     * The following will seem ugly and weird, but we need it
     * to remedy a bug with md table where functions passed to it
     * somehow inherit it's context for "this"
     * */
    let mlcContext = null;

    class MediaListController {
        constructor($translate, $filter, $sce, $location, $scope, ContactManagerTagService, ContactManagerNavigationService, $mdDialog, ActionBarService, emptyStateVisible, DialogService, $mdToast, EmailAnalyticsService){
            mlcContext = this;

            this.$mdToast = $mdToast;
            this.successToastMessage = $translate.instant('icm-web__media-lists--toast-list-updated');
            this.$scope = $scope;
            this.EmailAnalyticsService = EmailAnalyticsService;
            this.DialogService = DialogService;
            this.emptyStateVisible = emptyStateVisible;
            this.ActionBarService = ActionBarService;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.$filter = $filter;
            this.$location = $location;
            this.$sce = $sce;
            this.mediaListItems = [];
            this.ContactManagerTagService = ContactManagerTagService;
            this.title = this.$translate.instant('icm-web__media-lists--page-title');
            this.tableTitle = this.$translate.instant('icm-web__media-lists--table-title');
            this.updatedTableTitle = '';
            this.sortByInfoTitle = {
                sortOrderStr: this.$translate.instant('mw-content-stream-sort-menu__sort-order--ascending'),
                orderByStr: this.$translate.instant('icm-web__list-of-lists--sort-by-name')
            };
            this.nameHeaderTitle = this.$translate.instant('icm-web__media-lists--name-header-title');
            this.emailsSentHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--emails-sent');
            this.unsubscribeRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--unsubscribe-rate');
            this.openRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--open-rate');
            this.clickRateHeaderTitle = this.$translate.instant('icm-web__media-list-engagement--click-rate');
            this.lastUpdatedHeaderTitle = this.$translate.instant('icm-web__media-lists--date-header-title');
            this.lastUpdatedByHeaderTitle = this.$translate.instant('icm-web__media-lists--updated-by-header-title');
            this.createdHeaderTitle = this.$translate.instant('icm-web__media-lists--created-on-header-title');
            this.createdByHeaderTitle = this.$translate.instant('icm-web__media-lists--created-by-header-title');
            this.tablePaginationLabel = this.$translate.instant('mw-collection__table-pagination-of');
            this.sortToolTip = this.$translate.instant('mw-collection__tooltip-sort');
            this.selectedItems = 0;
            this.isSearchActive = false;
            this.findText = '';
            this.paging = {
                itemsPerPage: 25,
                selectedPage: 1,
                orderBy: 'name',
                sortOrder: 'asc',
                //default sorting
            };
            this.pageStart = 1;
            this.pageEnd = 25;

            this.mediaListTotal = 0;
            this.selectedItems = [];
            this.getMediaLists();
            this.preserveScroll = '';
            this.loadPromise = null;
            this.actions = [
                {
                    label: this.$translate.instant('icm-contact-add-landing__breadcrumb-title'),
                    icon: 'social:ic_person_add_24px',
                    onClick: ()=>{ this.navigateToUrl('influencers/contact/landing'); },
                    enabled: true
                },
                {
                    label: this.$translate.instant('icm-contact-add-landing__action-search-contacts--action'),
                    icon: 'action:ic_search_24px',
                    onClick: ()=>{ ContactManagerNavigationService.goToSearch(); },
                    enabled: true
                },
                {
                    label: this.$translate.instant('icm-web__action-bar--all-contacts'),
                    icon: 'social:ic_group_24px',
                    onClick: ()=>{ this.navigateToUrl('influencers/contact-list'); },
                    enabled: true
                }
            ];

            this.ActionBarService.registerActions(this.actions);
            this.loading = true;
        }

        reloadCurrentPage() {
            let mdElements = angular.element('md-content');

            for(let key in mdElements){
                if(mdElements && mdElements[key].className && mdElements[key].className === 'mw-flex-padding _md flex'){
                    this.preserveScroll = mdElements[key].scrollTop;
                    break;
                }
            }

            this.getMediaLists(mlcContext.paging.selectedPage, mlcContext.paging.itemsPerPage, this.getSortOrder(), mlcContext.findText).then(()=>{
                if (this.mediaListItems === 0 ) {
                    this.emptyStateVisible = true;
                }
                else {
                    for(let key in mdElements){
                        if(mdElements && mdElements[key].className && mdElements[key].className === 'mw-flex-padding _md flex'){
                            mdElements[key].scrollTop = this.preserveScroll;
                            break;
                        }
                    }
                }
            });

        }

        getMediaLists(page=1, size=25, sort='NAME_ASC', q='') {
            this.loading = true;
            if(!this.loadPromise) {
                this.loadPromise = new Promise((resolve, reject) => {
                    this.ContactManagerTagService.getAllTags(page, size, sort, q).then((response) => {
                        this.loadPromise = null;
                        this.mediaListItems = response.mediaLists;
                        this.mediaListTotal = response.count;
                        this.updatePageInfo();
                        this.updatedTableTitle = this.mediaListTotal + ' ' + this.tableTitle;
                        this.loading = false;
                        this.$scope.$digest();
                        resolve(this.mediaListItems);
                    }).catch((error) => {
                        this.medialistItems = [];
                        this.updatedTableTitle = this.mediaListItems.length + ' ' + this.tableTitle;
                        this.loading = false;
                        reject(error);
                    });
                });
            }
            return this.loadPromise;
        }

        isHeaderTitleVisible() {
            return true;
        }

        isSearchVisible() {
            return true;
        }

        onSearchToggle(isSearchActive) {
            this.isSearchActive = isSearchActive;
        }

        search(findText) {
            if (findText.length === 0 || findText.length >= 3) {
                this.findText = findText;
                this.page(1);
            }
        }

        cannotFindList() {
            return (!this.loading && this.mediaListTotal === 0 && this.findText.length >= 3);
        }

        _scrollTableIntoView() {
            // when paging through the table, put it back into view
            document.getElementById('mediaListManagement').scrollIntoView();
        }

        nextPage() {
            let nextPageNumber = (mlcContext.paging.selectedPage + 1);
            mlcContext.page(nextPageNumber);
        }

        previousPage() {
            let previousPageNumber = (mlcContext.paging.selectedPage - 1);
            mlcContext.page(previousPageNumber);
        }

        page(pageNumber) {
            mlcContext._scrollTableIntoView();

            mlcContext.isDataLoaded = false;
            mlcContext.paging.selectedPage = pageNumber;

            mlcContext.getMediaLists(pageNumber, 25, mlcContext.getSortOrder(), mlcContext.findText);
        }

        updatePageInfo() {
            mlcContext.pageStart = ((mlcContext.paging.itemsPerPage * (mlcContext.paging.selectedPage - 1)) + 1);
            mlcContext.pageEnd = Math.min((mlcContext.paging.itemsPerPage * mlcContext.paging.selectedPage), mlcContext.mediaListTotal);
            if (mlcContext.mediaListTotal === 0) {
                mlcContext.pageEnd = 0;
                mlcContext.pageStart = 0;
            }
            else if (mlcContext.mediaListTotal < mlcContext.pageEnd) {
                mlcContext.pageEnd = mlcContext.mediaListTotal;
            }
        }

        getSortOrder(){
            return mlcContext.paging.orderBy.toUpperCase() + '_' + mlcContext.paging.sortOrder.toUpperCase();
        }

        isCurrentSort(orderBy) {
            return mlcContext.paging.orderBy === orderBy;
        }

        setOrderBy(orderBy){
            mlcContext.paging.orderBy = orderBy;
            mlcContext.page(1);
            this.setSortOrderInfoString();
        }

        setOrdering(order){
            mlcContext.paging.sortOrder = order;
            mlcContext.page(1);
            this.setSortOrderInfoString();
        }

        isAscending() {
            return mlcContext.paging.sortOrder === 'asc';
        }

        setSortOrderInfoString(){
            switch(mlcContext.paging.orderBy){
                case('name'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-name');
                    break;
                case('updated'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-updated');
                    break;
                case('lastUpdatedBy'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-updated-by');
                    break;
                case('created'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-created');
                    break;
                case('createdBy'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-created-by');
                    break;
                case('distributions'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-distributions');
                    break;
                case('openRate'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-openRate');
                    break;
                case('clickToOpenRate'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-clickToOpenRate');
                    break;
                case('unsubscribeRate'):
                    this.sortByInfoTitle.orderByStr = this.$translate.instant('icm-web__list-of-lists--sort-by-unsubscribeRate');
                    break;
                default:
                    break;
            }

            this.sortByInfoTitle.sortOrderStr = (mlcContext.paging.sortOrder === 'asc') ? this.$translate.instant('mw-content-stream-sort-menu__sort-order--ascending') : this.$translate.instant('mw-content-stream-sort-menu__sort-order--descending');
        }

        navigateToMediaList(mediaListId) {
            this.navigateToUrl('influencers/contact-list/' + mediaListId);
        }

        navigateToUrl(url){
            this.$location.url(url);
        }
    }

    angular.module('MW.ContactManager.MediaListController', [
        'ngMaterial',
        'MW.CoreStream.ContactManagerTagService',
        'MW.Influencers.ActionBarService',
        'MW.ContactManager.MwMediaListUpdateModal',
        'MW.Influencers.IcmDialogService',
        'MW.Influencers.EmailAnalyticsService',
        'MW.ContactManager.MwMediaListCard',
        'MW.ContactManager.ContactManagerNavigationService'
    ])
    .controller('MediaListController', ['$translate', '$filter', '$sce', '$location', '$scope', 'ContactManagerTagService', 'ContactManagerNavigationService', '$mdDialog', 'ActionBarService', 'emptyStateVisible', 'DialogService', '$mdToast', 'EmailAnalyticsService', MediaListController]);
}(window.angular));
